export default class DiffieHellmanAES {
    constructor() {
        // Initialize properties to null
        this.keyPair = null;
        this.publicKey = null;
        this.publicKeyHex = null;
        this.computeSharedSecret = this.computeSharedSecret.bind(this);
    }

    initialize = async () => {
        if (!window.crypto || !window.crypto.subtle) {
            console.error("Web Crypto API is not supported in this environment.");
            return;
        }
        try {
            await this.setupKeys();
        } catch (error) {
            console.error("Error in initialize:", error);
        }
    }

    setupKeys = async () => {
        try {
            this.keyPair = await window.crypto.subtle.generateKey(
                {
                    name: "ECDH",
                    namedCurve: "P-256",
                },
                true, 
                ["deriveKey", "deriveBits"]
            );

            if (!this.keyPair) {
                console.error("Key pair not generated!");
                return;
            }
    
            this.publicKey = await window.crypto.subtle.exportKey('raw', this.keyPair.publicKey);
    
            if (!this.publicKey) {
                console.error("Public key not exported!");
                return;
            }
    
            this.publicKeyHex = this.arrayBufferToHex(this.publicKey);
    
        } catch (error) {
            console.error("Error in setupKeys:", error);
        }
    }

    computeSharedSecret = async (serverPublicKeyHex) => {
        const serverPublicKeyArrayBuffer = this.hexStringToArrayBuffer(serverPublicKeyHex);
        const importedServerKey = await window.crypto.subtle.importKey('raw', serverPublicKeyArrayBuffer, { name: 'ECDH', namedCurve: 'P-256' }, true, []);
        const aesKey = await window.crypto.subtle.deriveKey(
            {
                name: 'ECDH',
                namedCurve: 'P-256',
                public: importedServerKey
            },
            this.keyPair.privateKey,
            {
                name: "AES-CBC",
                length: 256  // AES-256
            },
            true,
            ["encrypt", "decrypt"]
        );

        return aesKey;
    }

    aesEncrypt = async (data, aesKey) => {
        const iv = new Uint8Array(16); // Zeroed out IV
        const encrypted = await window.crypto.subtle.encrypt(
            {
                name: "AES-CBC",
                iv: iv
            },
            aesKey,
            data
        );
        return new Uint8Array(encrypted);
    }
    
    aesDecrypt = async (data, aesKey) => {
        const iv = new Uint8Array(16); // Zeroed out IV
        const decrypted = await window.crypto.subtle.decrypt(
            {
                name: "AES-CBC",
                iv: iv
            },
            aesKey,
            data
        );
        return new Uint8Array(decrypted);
    }
    

    arrayBufferToHex = (buffer) => {
        return Array.prototype.map.call(new Uint8Array(buffer), x => ('00' + x.toString(16)).slice(-2)).join('');
    }

    hexStringToArrayBuffer = (hexString) => {
        if (hexString.length % 2 !== 0) {
            console.error("Invalid hexString");
            return new ArrayBuffer(0);
        }
        let array = new Uint8Array(hexString.length / 2);
        for (let i = 0; i < hexString.length; i += 2) {
            array[i / 2] = parseInt(hexString.substring(i, i + 2), 16);
        }
        return array.buffer;
    }
}
